import { fetch } from '@/shared/fetch';
import { ConsultationTypeEnum } from '@/shared/enums';

export const fetchPreviouslySelectedCaregiverUid = async (
    consultationType: ConsultationTypeEnum,
): Promise<string | null> => {
    return await fetch(
        `/api/consultations/previously-selected-caregiver/${consultationType}`,
    );
};
